import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//配件交易频次接口服务
class dinoutService {
    /*****************************************************************************/

    //分页查询销售单信息
    static async findPage(data) {
        const apiUrl = "/statistics/purchaseAndSalesAndDeposit";
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/sale/so/export`;
        return await download(apiUrl, {type: "POST", data});
    }


    /*****************************************************************************/
}

export default dinoutService;
